import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// ----- Imports ----- //
import { Outset } from 'components/content/content';
import Tabs from 'components/tabs/tabs';
import { Collection, HomeDelivery, } from 'helpers/productPrice/fulfilmentOptions';
import { ContentDeliveryFaqBlock } from './content/deliveryTab';
import { SubsCardFaqBlock } from './content/subsCardTab';
export const tabs = {
    HomeDelivery: {
        name: 'Home Delivery',
        href: `#${HomeDelivery}`,
        content: ContentDeliveryFaqBlock,
    },
    Collection: {
        name: 'Subscription Card',
        href: `#${Collection}`,
        content: SubsCardFaqBlock,
    },
};
// ----- Component ----- //
function PaperTabs({ selectedTab, setTabAction }) {
    const tabOptions = Object.keys(tabs);
    const tabItems = tabOptions.map((fulfilmentMethod) => {
        const TabContent = tabs[fulfilmentMethod].content;
        return {
            id: fulfilmentMethod,
            text: tabs[fulfilmentMethod].name,
            href: tabs[fulfilmentMethod].href,
            selected: fulfilmentMethod === selectedTab,
            content: _jsx(TabContent, {}),
        };
    });
    return (_jsx(Outset, { children: _jsx(Tabs, { tabsLabel: "Paper subscription options", tabElement: "a", tabs: tabItems, onTabChange: (tabId) => {
                const newActiveTab = tabId;
                setTabAction(newActiveTab);
            } }) }));
} // ----- Exports ----- //
export default PaperTabs;
